// extracted by mini-css-extract-plugin
export default {"contactDetails":"styles_contactDetails__GsBRK","formItem":"styles_formItem__53xbk","formItemCol":"styles_formItemCol__ksc32"};